import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress, Grid } from '@material-ui/core';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import clsx from 'clsx';
import { useRitzTranslation } from '../../utils/customHooks';
import { RCHomeRobotsDashboardContainer } from './RCHomeRobotsDashboardContainer';



/**
 * This page Display ALL a Robots latest data for a Home
 */
export const RCHomeRobotsStatusPage = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const userId = params.userId ? Number(params.userId) : undefined;        // userId is OPTIONAL depending on which route the user is on
    const homeId = Number(params.homeId);

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);
    const { trans } = useRitzTranslation(project);

    // The child's action that needs to be shown in the page's title bar as the main action.
    // This is a way for the page to show a UI component created and controlled by a child components
    const [pageMainAction, setPageMainAction] = useState<JSX.Element | undefined>();


    return (
        <div className={clsx('page-main-content')}>
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.home_robots_status')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.home_robots_status')}
                    </div>
                </div>
                {pageMainAction}
            </div>

            {project && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <RCHomeRobotsDashboardContainer
                            projectId={projectId}
                            userId={userId}
                            homeId={homeId}
                            setPageMainAction={setPageMainAction}
                        />
                    </Grid>
                </Grid>
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
